import React, {Component} from 'react';

// import SwitchButton from 'react-switch-button';
import {Row, Col} from 'react-bootstrap';

import Container from '../../components/Container';
import Heading from '../../components/Heading';

import API from '../../services/API';

import PlainSendForm from './components/PlainSendForm';
import MessageSendForm from './components/MessageSendForm';


class Send extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            isMessage: false,
            segments: [],
            messages: [],
            defaultMessages: []
        }

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSwitchChange = this.handleSwitchChange.bind(this);
    }

    componentDidMount() {
        this.loadSegments();
        this.loadMessages();
    }

    loadSegments() {
        API.Segments.get().then((segments) => {
            this.setState({segments});
        });
    }

    loadMessages() {
        API.Messages.getNames().then((messages) => {
            this.setState(messages);
        });
    }

    getForm() {
        const {isMessage} = this.state;

        if(isMessage) {
            return (
                <MessageSendForm
                    segments={this.state.segments}
                    messages={this.state.messages}
                    defaultMessages={this.state.defaultMessages}
                    onSubmit={this.handleSubmit}
                />
            );
        }

        return (
            <PlainSendForm
                segments={this.state.segments}
                onSubmit={this.handleSubmit}
            />
        );
    }

    handleSubmit(data) {
        console.log(data);
        this.setState({
            isLoading: true
        });
        API.Notifications.send(data).then(res => {
            this.setState({
                isLoading: false
            });

            console.log(res);
            if(res.notification) {
                this.props.history.push(`/notification/${res.notification}`)
            }
        });
    }

    handleSwitchChange(event) {
        const isMessage = event.target.checked;
        console.log(isMessage);
        this.setState({isMessage});
    }

    render() {
        return (
            <Container loading={this.state.isLoading}>
                <Heading title="Send"/>
                <Row className="m-b-15">
                    <Col lg={12}>
                        {/*<SwitchButton*/}
                            {/*name="isMessage"*/}
                            {/*theme="rsbc-switch-button-flat-square"*/}
                            {/*labelRight="Message"*/}
                            {/*onChange={this.handleSwitchChange}*/}
                        {/*/>*/}
                    </Col>
                </Row>
                <Row>
                    <Col lg={12}>
                        {/*<PlainSendForm*/}
                            {/*segments={this.state.segments}*/}
                            {/*onSubmit={this.handleSubmit}*/}
                        {/*/>*/}
                        {this.getForm()}
                    </Col>
                </Row>
            </Container>
        );
    }
}


export default Send;


// WEBPACK FOOTER //
// ./src/scenes/Send/index.js